import { Dialog } from "primereact/dialog";
import { Divider } from "primereact/divider";
import { Button } from "primereact/button";

export interface JustificationDialogProps {
    header: string;
    message: string;
    style?: React.CSSProperties;
    visible: boolean;
    onHide: () => void;
    isReadOnly: boolean;
    reasons: any[];
    selectedReasonIds: any[];
    userReason: string;
    onReasonChange: (e: any) => void;
    onUserReasonChange: (val: string) => void;
    onSave?: () => void;
    loading?: boolean;
}

export default function JustificationDialog({
    header,
    message,
    style,
    visible,
    onHide,
    isReadOnly,
    reasons,
    selectedReasonIds,
    //userReason,
    //onReasonChange,
    //onUserReasonChange,
    onSave,
    loading = false
}: JustificationDialogProps) {
return (
    //handle this popup properly
    <Dialog
        
         header={header} visible={visible} style={style} onHide={onHide}>
            <p className="m-0">{message}</p>
        <Divider />
        {loading ? (
            <div style={{ color: 'gray', marginBottom: '1rem' }}>
                Loading failed reasons...
            </div>
        ) : reasons.length === 0 ? (
            <div style={{ color: 'gray', marginBottom: '1rem' }}>
                No failed reasons available for this measure.
            </div>
        ) : (
            reasons.filter(x => selectedReasonIds.includes(x.reasonId)).map((reason: any) => (
                <div key={reason.reasonId} className="flex align-items-center">
                <li style={{ listStyleType: 'disc', marginLeft: '1rem' }}>
                    {reason.reasonText}
                </li>
                </div>
            ))
        )}
        <br />
        {/* <InputTextarea
            value={userReason}
            onChange={(e) => !isReadOnly && onUserReasonChange(e.target.value)}
            autoResize
            rows={5}
            cols={70}
            disabled={isReadOnly}
        /> */}
        <Divider />
        <div style={{ display: 'flex', justifyContent: "space-between" }}>
            <Button onClick={onSave} disabled={isReadOnly}>Edit</Button>
            <Button
                onClick={onHide}
                disabled={isReadOnly || selectedReasonIds.length === 0}
            >
                Ok
            </Button>
        </div>
    </Dialog>
);
}